export default __webpack_public_path__ + "static/media/other-data-glyph-16px.7aa71626.svg";